export default class RewardsInProgressResponse {
    constructor (json) {
        this._offers = json.offerRewardDetails
        this.successful = json.responseCode === 'SUCCESS'
    }

    success () {
        return this.successful
    }

    offers () {
        return this._offers
    }
}

// {
//     "responseCode": "SUCCESS",
//     "offerRewardDetails": [
//         {
//             "curPurchaseBal": "1.00",
//             "offerId": 342853,
//             "offerDescription": "Fountain Drink Club (Buy 5)",
//             "offerRequirement": "5.0",
//             "unitType": "QTY",
//             "offerStartDate": "2019-02-04 00:00:00",
//             "offerEndDate": "2050-12-31 23:59:59",
//             "retailerId": "CR1001",
//             "retailerName": "BellStores",
//             "rewardAmount": "100.0",
//             "rewardType": "PERCNT_OFF",
//             "rewardUnits": "1",
//             "sourceType": "",
//             "purchaseBalExpDate": "",
//             "offerCategories": [],
//             "siteCount": 0,
//             "memberBalance": "0.00",
//             "offerEarned": "",
//             "imageName": "app-offer-bellstores-fountaindrink"
//         },
//         {
//             "curPurchaseBal": "0.00",
//             "offerId": 342273,
//             "offerDescription": "Coffee Club (Buy 5)",
//             "offerRequirement": "5.0",
//             "unitType": "QTY",
//             "offerStartDate": "2019-01-12 00:00:00",
//             "offerEndDate": "2050-12-31 23:59:59",
//             "retailerId": "CR1001",
//             "retailerName": "BellStores",
//             "rewardAmount": "100.0",
//             "rewardType": "PERCNT_OFF",
//             "rewardUnits": "1",
//             "sourceType": "",
//             "purchaseBalExpDate": "",
//             "offerCategories": [],
//             "siteCount": 0,
//             "memberBalance": "0.00",
//             "offerEarned": "",
//             "imageName": "app-offer-bellstores-coffee"
//         },
//         {
//             "curPurchaseBal": "12.51",
//             "offerId": 340998,
//             "offerDescription": "BellStores Basket Offer ",
//             "offerRequirement": "25.0",
//             "unitType": "USD",
//             "offerStartDate": "2019-01-14 00:00:00",
//             "offerEndDate": "2099-11-12 23:59:59",
//             "retailerId": "CR1001",
//             "retailerName": "BellStores",
//             "rewardAmount": "0.05",
//             "rewardType": "CPG",
//             "rewardUnits": "0",
//             "sourceType": "",
//             "purchaseBalExpDate": "",
//             "offerCategories": [],
//             "siteCount": 0,
//             "memberBalance": "0.00",
//             "offerEarned": "",
//             "imageName": "app-offer-bellstores-basket"
//         }
//     ]
// }



// WEBPACK FOOTER //
// ./src/models/responses/RewardsInProgressResponse.js